import L from 'leaflet';
import { Alarms } from './utils/constants';

const DeviceTypes = {
  PIVOT: 'pivot',
  ECHO: 'echo'
};

const AlarmColors = {
  [Alarms.CRITICAL]: '#C60000',
  [Alarms.MAJOR]: '#F36E21',
  [Alarms.MINOR]: '#F3B721',
  [Alarms.WARNING]: '#F3B721',
  [Alarms.INFO]: '#797B82',
  [Alarms.CLEARED]: '#FFFFFF'
};

export function deviceIcon({ deviceType, alarmLevel, selected = false, className }) {
  // @todo fix icon size and anchor point
  return L.divIcon({
    html: createDeviceIcon({ deviceType, alarmLevel, selected }),
    className
  });
}

function createDeviceIcon({ deviceType, alarmLevel, selected }) {
  switch (deviceType) {
    case DeviceTypes.PIVOT:
      return createPivotDeviceIcon({ alarmLevel, selected });
    case DeviceTypes.ECHO:
      return createEchoDeviceIcon({ alarmLevel, selected });
    default:
      return null;
  }
}

function createEchoDeviceIcon({ alarmLevel, selected }) {
  if (alarmLevel != null) {
    switch (alarmLevel) {
      case Alarms.CRITICAL:
        return createEchoDeviceCriticalIcon();
      case Alarms.MAJOR:
        return createEchoDeviceMajorIcon();
      case Alarms.MINOR:
        return createEchoDeviceMinorIcon();
      case Alarms.WARNING:
        return createEchoDeviceWarningIcon();
      case Alarms.INFO:
        return createEchoDeviceInfoIcon();
      default:
        return createEchoDeviceClearedIcon();
    }
  }

  return createEchoDeviceDefaultIcon({ selected });
}

function createEchoDeviceDefaultIcon({ selected }) {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill=${selected ? '#009CFD' : '#005082'} cx="7" cy="7" r="7" />
        <path
          d="M4.826,7.272 L10.81,7.272 C10.832,7.206 10.843,7.129 10.843,6.986 C10.843,4.874 9.435,3.741 7.268,3.741 C4.947,3.741 3.561,4.995 3.561,6.997 C3.561,8.977 4.947,10.231 7.356,10.231 C8.764,10.231 9.809,9.89 10.634,9.153 L9.886,8.35 C9.226,8.933 8.533,9.219 7.422,9.219 C5.904,9.219 4.947,8.581 4.826,7.272 Z M7.279,4.753 C8.467,4.753 9.325,5.248 9.6,6.348 L4.881,6.359 C5.123,5.292 6.014,4.753 7.279,4.753 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceClearedIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#009527" fill="#FFFFFF" cx="7" cy="7" r="6.5" />
        <path
          d="M5.16949153,7.26440678 L10.7016949,7.26440678 C10.7220339,7.20338983 10.7322034,7.13220339 10.7322034,7 C10.7322034,5.04745763 9.43050847,4 7.42711864,4 C5.28135593,4 4,5.15932203 4,7.01016949 C4,8.84067797 5.28135593,10 7.50847458,10 C8.81016949,10 9.77627119,9.68474576 10.5389831,9.00338983 L9.84745763,8.26101695 C9.23728814,8.8 8.59661017,9.06440678 7.56949153,9.06440678 C6.16610169,9.06440678 5.28135593,8.47457627 5.16949153,7.26440678 Z M7.43728814,4.93559322 C8.53559322,4.93559322 9.32881356,5.39322034 9.58305085,6.41016949 L5.22033898,6.42033898 C5.4440678,5.43389831 6.26779661,4.93559322 7.43728814,4.93559322 Z"
          fill="#009527"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceInfoIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill="#7D7D7D" cx="7" cy="7" r="7" />
        <path
          d="M5.16949153,7.26440678 L10.7016949,7.26440678 C10.7220339,7.20338983 10.7322034,7.13220339 10.7322034,7 C10.7322034,5.04745763 9.43050847,4 7.42711864,4 C5.28135593,4 4,5.15932203 4,7.01016949 C4,8.84067797 5.28135593,10 7.50847458,10 C8.81016949,10 9.77627119,9.68474576 10.5389831,9.00338983 L9.84745763,8.26101695 C9.23728814,8.8 8.59661017,9.06440678 7.56949153,9.06440678 C6.16610169,9.06440678 5.28135593,8.47457627 5.16949153,7.26440678 Z M7.43728814,4.93559322 C8.53559322,4.93559322 9.32881356,5.39322034 9.58305085,6.41016949 L5.22033898,6.42033898 C5.4440678,5.43389831 6.26779661,4.93559322 7.43728814,4.93559322 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceWarningIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill="#F3B721" cx="7" cy="7" r="7" />
        <path
          d="M5.16949153,7.26440678 L10.7016949,7.26440678 C10.7220339,7.20338983 10.7322034,7.13220339 10.7322034,7 C10.7322034,5.04745763 9.43050847,4 7.42711864,4 C5.28135593,4 4,5.15932203 4,7.01016949 C4,8.84067797 5.28135593,10 7.50847458,10 C8.81016949,10 9.77627119,9.68474576 10.5389831,9.00338983 L9.84745763,8.26101695 C9.23728814,8.8 8.59661017,9.06440678 7.56949153,9.06440678 C6.16610169,9.06440678 5.28135593,8.47457627 5.16949153,7.26440678 Z M7.43728814,4.93559322 C8.53559322,4.93559322 9.32881356,5.39322034 9.58305085,6.41016949 L5.22033898,6.42033898 C5.4440678,5.43389831 6.26779661,4.93559322 7.43728814,4.93559322 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceMinorIcon() {
  return `
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#F3B721" cx="9" cy="9" r="8.5" />
        <path
          d="M3,9 C3,12.314 5.686,15 9,15 C12.314,15 15,12.314 15,9 C15,5.686 12.314,3 9,3 C5.686,3 3,5.686 3,9 Z"
          fill="#F3B721"
          fill-rule="nonzero"
        />
        <path
          d="M6.826,9.272 L12.81,9.272 C12.832,9.206 12.843,9.129 12.843,8.986 C12.843,6.874 11.435,5.741 9.268,5.741 C6.947,5.741 5.561,6.995 5.561,8.997 C5.561,10.977 6.947,12.231 9.356,12.231 C10.764,12.231 11.809,11.89 12.634,11.153 L11.886,10.35 C11.226,10.933 10.533,11.219 9.422,11.219 C7.904,11.219 6.947,10.581 6.826,9.272 Z M9.279,6.753 C10.467,6.753 11.325,7.248 11.6,8.348 L6.881,8.359 C7.123,7.292 8.014,6.753 9.279,6.753 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceMajorIcon() {
  return `
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#F36E21" fill="#FFFFFF" cx="10" cy="10" r="9.5" />
        <path
          d="M4,10 C4,13.314 6.686,16 10,16 C13.314,16 16,13.314 16,10 C16,6.686 13.314,4 10,4 C6.686,4 4,6.686 4,10 Z"
          fill="#F36E21"
          fill-rule="nonzero"
        />
        <path
          d="M7.826,10.272 L13.81,10.272 C13.832,10.206 13.843,10.129 13.843,9.986 C13.843,7.874 12.435,6.741 10.268,6.741 C7.947,6.741 6.561,7.995 6.561,9.997 C6.561,11.977 7.947,13.231 10.356,13.231 C11.764,13.231 12.809,12.89 13.634,12.153 L12.886,11.35 C12.226,11.933 11.533,12.219 10.422,12.219 C8.904,12.219 7.947,11.581 7.826,10.272 Z M10.279,7.753 C11.467,7.753 12.325,8.248 12.6,9.348 L7.881,9.359 C8.123,8.292 9.014,7.753 10.279,7.753 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createEchoDeviceCriticalIcon() {
  return `
    <svg width="22" height="22" viewBox="0 0 22 22">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#C60000" fill="#FFFFFF" cx="11" cy="11" r="9" />
        <circle stroke="#C60000" cx="11" cy="11" r="10.5" />
        <path
          d="M0,6 C0,9.314 2.686,12 6,12 C9.314,12 12,9.314 12,6 C12,2.686 9.314,0 6,0 C2.686,0 0,2.686 0,6 Z"
          fill="#C60000"
          fill-rule="nonzero"
          transform="translate(5.000000, 5.000000)"
        />
        <path
          d="M8.826,11.272 L14.81,11.272 C14.832,11.206 14.843,11.129 14.843,10.986 C14.843,8.874 13.435,7.741 11.268,7.741 C8.947,7.741 7.561,8.995 7.561,10.997 C7.561,12.977 8.947,14.231 11.356,14.231 C12.764,14.231 13.809,13.89 14.634,13.153 L13.886,12.35 C13.226,12.933 12.533,13.219 11.422,13.219 C9.904,13.219 8.947,12.581 8.826,11.272 Z M11.279,8.753 C12.467,8.753 13.325,9.248 13.6,10.348 L8.881,10.359 C9.123,9.292 10.014,8.753 11.279,8.753 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceIcon({ alarmLevel, selected }) {
  if (alarmLevel != null) {
    switch (alarmLevel) {
      case Alarms.CRITICAL:
        return createPivotDeviceCriticalIcon();
      case Alarms.MAJOR:
        return createPivotDeviceMajorIcon();
      case Alarms.MINOR:
        return createPivotDeviceMinorIcon();
      case Alarms.WARNING:
        return createPivotDeviceWarningIcon();
      case Alarms.INFO:
        return createPivotDeviceInfoIcon();
      default:
        return createPivotDeviceClearedIcon();
    }
  }

  return createPivotDeviceDefaultIcon({ selected });
}

function createPivotDeviceDefaultIcon({ selected }) {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
        <circle fill=${selected ? '#FFBA8F' : '#F36E21'} cx="7" cy="7" r="7" />
        <path
          d="M5.584 11.09a.246.246 0 00.253-.253V8.274c.403.557.997.836 1.782.836.77 0 1.348-.246 1.732-.737.385-.491.589-1.111.611-1.859.007-.08.011-.205.011-.374s-.004-.293-.011-.374c-.022-.755-.226-1.377-.61-1.865-.386-.487-.963-.731-1.733-.731-.785 0-1.39.282-1.815.847v-.484c0-.08-.022-.143-.066-.187-.044-.044-.106-.066-.187-.066h-.462a.257.257 0 00-.182.066.242.242 0 00-.071.187v7.304c0 .08.024.143.071.187a.257.257 0 00.182.066h.495zM7.41 8.252c-.499 0-.882-.163-1.15-.49a1.874 1.874 0 01-.423-1.16 5.558 5.558 0 01-.011-.429c0-.205.004-.348.011-.429A2.04 2.04 0 016.25 4.54c.26-.341.647-.512 1.16-.512 1.041 0 1.562.704 1.562 2.112 0 .14-.004.246-.011.319-.022.535-.154.968-.396 1.298-.242.33-.627.495-1.155.495z"
          fill="#FFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceClearedIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#009527" fill="#FFFFFF" cx="7" cy="7" r="6.5" />
        <path
          d="M5.72805139,11 C5.79942898,11 5.85831549,10.9759259 5.90471092,10.9277778 C5.95110635,10.8796296 5.97430407,10.8185185 5.97430407,10.7444444 L5.97430407,10.7444444 L5.97430407,8.15555556 C6.3668808,8.71851852 6.94503926,9 7.70877944,9 C8.45824411,9 9.02034261,8.75185185 9.39507495,8.25555556 C9.76980728,7.75925926 9.96788009,7.13333333 9.98929336,6.37777778 C9.99643112,6.2962963 10,6.17037037 10,6 C10,5.82962963 9.99643112,5.7037037 9.98929336,5.62222222 C9.96788009,4.85925926 9.76980728,4.23148148 9.39507495,3.73888889 C9.02034261,3.2462963 8.45824411,3 7.70877944,3 C6.94503926,3 6.35617416,3.28518519 5.94218415,3.85555556 L5.94218415,3.85555556 L5.94218415,3.36666667 C5.94218415,3.28518519 5.92077088,3.22222222 5.87794433,3.17777778 C5.83511777,3.13333333 5.77444682,3.11111111 5.69593148,3.11111111 L5.69593148,3.11111111 L5.24625268,3.11111111 C5.17487509,3.11111111 5.11598858,3.13333333 5.06959315,3.17777778 C5.02319772,3.22222222 5,3.28518519 5,3.36666667 L5,3.36666667 L5,10.7444444 C5,10.8259259 5.02319772,10.8888889 5.06959315,10.9333333 C5.11598858,10.9777778 5.17487509,11 5.24625268,11 L5.24625268,11 L5.72805139,11 Z M7.50535332,8.13333333 C7.01998572,8.13333333 6.64703783,7.96851852 6.38650964,7.63888889 C6.12598144,7.30925926 5.98857959,6.91851852 5.97430407,6.46666667 C5.96716631,6.38518519 5.96359743,6.24074074 5.96359743,6.03333333 C5.96359743,5.82592593 5.96716631,5.68148148 5.97430407,5.6 C5.98857959,5.13333333 6.12241256,4.72777778 6.375803,4.38333333 C6.62919343,4.03888889 7.00571021,3.86666667 7.50535332,3.86666667 C8.51891506,3.86666667 9.02569593,4.57777778 9.02569593,6 C9.02569593,6.14074074 9.02212705,6.24814815 9.01498929,6.32222222 C8.99357602,6.86296296 8.86509636,7.3 8.62955032,7.63333333 C8.39400428,7.96666667 8.01927195,8.13333333 7.50535332,8.13333333 Z"
          fill="#009527"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceInfoIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill="#7D7D7D" cx="7" cy="7" r="7" />
        <path
          d="M5.72805139,11 C5.79942898,11 5.85831549,10.9759259 5.90471092,10.9277778 C5.95110635,10.8796296 5.97430407,10.8185185 5.97430407,10.7444444 L5.97430407,10.7444444 L5.97430407,8.15555556 C6.3668808,8.71851852 6.94503926,9 7.70877944,9 C8.45824411,9 9.02034261,8.75185185 9.39507495,8.25555556 C9.76980728,7.75925926 9.96788009,7.13333333 9.98929336,6.37777778 C9.99643112,6.2962963 10,6.17037037 10,6 C10,5.82962963 9.99643112,5.7037037 9.98929336,5.62222222 C9.96788009,4.85925926 9.76980728,4.23148148 9.39507495,3.73888889 C9.02034261,3.2462963 8.45824411,3 7.70877944,3 C6.94503926,3 6.35617416,3.28518519 5.94218415,3.85555556 L5.94218415,3.85555556 L5.94218415,3.36666667 C5.94218415,3.28518519 5.92077088,3.22222222 5.87794433,3.17777778 C5.83511777,3.13333333 5.77444682,3.11111111 5.69593148,3.11111111 L5.69593148,3.11111111 L5.24625268,3.11111111 C5.17487509,3.11111111 5.11598858,3.13333333 5.06959315,3.17777778 C5.02319772,3.22222222 5,3.28518519 5,3.36666667 L5,3.36666667 L5,10.7444444 C5,10.8259259 5.02319772,10.8888889 5.06959315,10.9333333 C5.11598858,10.9777778 5.17487509,11 5.24625268,11 L5.24625268,11 L5.72805139,11 Z M7.50535332,8.13333333 C7.01998572,8.13333333 6.64703783,7.96851852 6.38650964,7.63888889 C6.12598144,7.30925926 5.98857959,6.91851852 5.97430407,6.46666667 C5.96716631,6.38518519 5.96359743,6.24074074 5.96359743,6.03333333 C5.96359743,5.82592593 5.96716631,5.68148148 5.97430407,5.6 C5.98857959,5.13333333 6.12241256,4.72777778 6.375803,4.38333333 C6.62919343,4.03888889 7.00571021,3.86666667 7.50535332,3.86666667 C8.51891506,3.86666667 9.02569593,4.57777778 9.02569593,6 C9.02569593,6.14074074 9.02212705,6.24814815 9.01498929,6.32222222 C8.99357602,6.86296296 8.86509636,7.3 8.62955032,7.63333333 C8.39400428,7.96666667 8.01927195,8.13333333 7.50535332,8.13333333 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceWarningIcon() {
  return `
    <svg width="14" height="14" viewBox="0 0 14 14">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle fill="#F3B721" cx="7" cy="7" r="7" />
        <path
          d="M5.72805139,11 C5.79942898,11 5.85831549,10.9759259 5.90471092,10.9277778 C5.95110635,10.8796296 5.97430407,10.8185185 5.97430407,10.7444444 L5.97430407,10.7444444 L5.97430407,8.15555556 C6.3668808,8.71851852 6.94503926,9 7.70877944,9 C8.45824411,9 9.02034261,8.75185185 9.39507495,8.25555556 C9.76980728,7.75925926 9.96788009,7.13333333 9.98929336,6.37777778 C9.99643112,6.2962963 10,6.17037037 10,6 C10,5.82962963 9.99643112,5.7037037 9.98929336,5.62222222 C9.96788009,4.85925926 9.76980728,4.23148148 9.39507495,3.73888889 C9.02034261,3.2462963 8.45824411,3 7.70877944,3 C6.94503926,3 6.35617416,3.28518519 5.94218415,3.85555556 L5.94218415,3.85555556 L5.94218415,3.36666667 C5.94218415,3.28518519 5.92077088,3.22222222 5.87794433,3.17777778 C5.83511777,3.13333333 5.77444682,3.11111111 5.69593148,3.11111111 L5.69593148,3.11111111 L5.24625268,3.11111111 C5.17487509,3.11111111 5.11598858,3.13333333 5.06959315,3.17777778 C5.02319772,3.22222222 5,3.28518519 5,3.36666667 L5,3.36666667 L5,10.7444444 C5,10.8259259 5.02319772,10.8888889 5.06959315,10.9333333 C5.11598858,10.9777778 5.17487509,11 5.24625268,11 L5.24625268,11 L5.72805139,11 Z M7.50535332,8.13333333 C7.01998572,8.13333333 6.64703783,7.96851852 6.38650964,7.63888889 C6.12598144,7.30925926 5.98857959,6.91851852 5.97430407,6.46666667 C5.96716631,6.38518519 5.96359743,6.24074074 5.96359743,6.03333333 C5.96359743,5.82592593 5.96716631,5.68148148 5.97430407,5.6 C5.98857959,5.13333333 6.12241256,4.72777778 6.375803,4.38333333 C6.62919343,4.03888889 7.00571021,3.86666667 7.50535332,3.86666667 C8.51891506,3.86666667 9.02569593,4.57777778 9.02569593,6 C9.02569593,6.14074074 9.02212705,6.24814815 9.01498929,6.32222222 C8.99357602,6.86296296 8.86509636,7.3 8.62955032,7.63333333 C8.39400428,7.96666667 8.01927195,8.13333333 7.50535332,8.13333333 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceMinorIcon() {
  return `
    <svg width="18" height="18" viewBox="0 0 18 18">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#F3B721" fill="#FFFFFF" cx="9" cy="9" r="8.5" />
        <path
          d="M3,9 C3,12.314 5.686,15 9,15 C12.314,15 15,12.314 15,9 C15,5.686 12.314,3 9,3 C5.686,3 3,5.686 3,9 Z"
          fill="#F3B721"
          fill-rule="nonzero"
        />
        <path
          d="M7.72805139,13 C7.79942898,13 7.85831549,12.9759259 7.90471092,12.9277778 C7.95110635,12.8796296 7.97430407,12.8185185 7.97430407,12.7444444 L7.97430407,12.7444444 L7.97430407,10.1555556 C8.3668808,10.7185185 8.94503926,11 9.70877944,11 C10.4582441,11 11.0203426,10.7518519 11.3950749,10.2555556 C11.7698073,9.75925926 11.9678801,9.13333333 11.9892934,8.37777778 C11.9964311,8.2962963 12,8.17037037 12,8 C12,7.82962963 11.9964311,7.7037037 11.9892934,7.62222222 C11.9678801,6.85925926 11.7698073,6.23148148 11.3950749,5.73888889 C11.0203426,5.2462963 10.4582441,5 9.70877944,5 C8.94503926,5 8.35617416,5.28518519 7.94218415,5.85555556 L7.94218415,5.85555556 L7.94218415,5.36666667 C7.94218415,5.28518519 7.92077088,5.22222222 7.87794433,5.17777778 C7.83511777,5.13333333 7.77444682,5.11111111 7.69593148,5.11111111 L7.69593148,5.11111111 L7.24625268,5.11111111 C7.17487509,5.11111111 7.11598858,5.13333333 7.06959315,5.17777778 C7.02319772,5.22222222 7,5.28518519 7,5.36666667 L7,5.36666667 L7,12.7444444 C7,12.8259259 7.02319772,12.8888889 7.06959315,12.9333333 C7.11598858,12.9777778 7.17487509,13 7.24625268,13 L7.24625268,13 L7.72805139,13 Z M9.50535332,10.1333333 C9.01998572,10.1333333 8.64703783,9.96851852 8.38650964,9.63888889 C8.12598144,9.30925926 7.98857959,8.91851852 7.97430407,8.46666667 C7.96716631,8.38518519 7.96359743,8.24074074 7.96359743,8.03333333 C7.96359743,7.82592593 7.96716631,7.68148148 7.97430407,7.6 C7.98857959,7.13333333 8.12241256,6.72777778 8.375803,6.38333333 C8.62919343,6.03888889 9.00571021,5.86666667 9.50535332,5.86666667 C10.5189151,5.86666667 11.0256959,6.57777778 11.0256959,8 C11.0256959,8.14074074 11.0221271,8.24814815 11.0149893,8.32222222 C10.993576,8.86296296 10.8650964,9.3 10.6295503,9.63333333 C10.3940043,9.96666667 10.0192719,10.1333333 9.50535332,10.1333333 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceMajorIcon() {
  return `
    <svg width="20" height="20" viewBox="0 0 20 20">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#F36E21" fill="#FFFFFF" cx="10" cy="10" r="9.5" />
        <path
          d="M4,10 C4,13.314 6.686,16 10,16 C13.314,16 16,13.314 16,10 C16,6.686 13.314,4 10,4 C6.686,4 4,6.686 4,10 Z"
          fill="#F36E21"
          fill-rule="nonzero"
        />
        <path
          d="M8.72805139,14 C8.79942898,14 8.85831549,13.9759259 8.90471092,13.9277778 C8.95110635,13.8796296 8.97430407,13.8185185 8.97430407,13.7444444 L8.97430407,13.7444444 L8.97430407,11.1555556 C9.3668808,11.7185185 9.94503926,12 10.7087794,12 C11.4582441,12 12.0203426,11.7518519 12.3950749,11.2555556 C12.7698073,10.7592593 12.9678801,10.1333333 12.9892934,9.37777778 C12.9964311,9.2962963 13,9.17037037 13,9 C13,8.82962963 12.9964311,8.7037037 12.9892934,8.62222222 C12.9678801,7.85925926 12.7698073,7.23148148 12.3950749,6.73888889 C12.0203426,6.2462963 11.4582441,6 10.7087794,6 C9.94503926,6 9.35617416,6.28518519 8.94218415,6.85555556 L8.94218415,6.85555556 L8.94218415,6.36666667 C8.94218415,6.28518519 8.92077088,6.22222222 8.87794433,6.17777778 C8.83511777,6.13333333 8.77444682,6.11111111 8.69593148,6.11111111 L8.69593148,6.11111111 L8.24625268,6.11111111 C8.17487509,6.11111111 8.11598858,6.13333333 8.06959315,6.17777778 C8.02319772,6.22222222 8,6.28518519 8,6.36666667 L8,6.36666667 L8,13.7444444 C8,13.8259259 8.02319772,13.8888889 8.06959315,13.9333333 C8.11598858,13.9777778 8.17487509,14 8.24625268,14 L8.24625268,14 L8.72805139,14 Z M10.5053533,11.1333333 C10.0199857,11.1333333 9.64703783,10.9685185 9.38650964,10.6388889 C9.12598144,10.3092593 8.98857959,9.91851852 8.97430407,9.46666667 C8.96716631,9.38518519 8.96359743,9.24074074 8.96359743,9.03333333 C8.96359743,8.82592593 8.96716631,8.68148148 8.97430407,8.6 C8.98857959,8.13333333 9.12241256,7.72777778 9.375803,7.38333333 C9.62919343,7.03888889 10.0057102,6.86666667 10.5053533,6.86666667 C11.5189151,6.86666667 12.0256959,7.57777778 12.0256959,9 C12.0256959,9.14074074 12.0221271,9.24814815 12.0149893,9.32222222 C11.993576,9.86296296 11.8650964,10.3 11.6295503,10.6333333 C11.3940043,10.9666667 11.0192719,11.1333333 10.5053533,11.1333333 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

function createPivotDeviceCriticalIcon() {
  return `
    <svg width="22" height="22" viewBox="0 0 22 22">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle stroke="#C60000" fill="#FFFFFF" cx="11" cy="11" r="9" />
        <circle stroke="#C60000" cx="11" cy="11" r="10.5" />
        <path
          d="M0,6 C0,9.314 2.686,12 6,12 C9.314,12 12,9.314 12,6 C12,2.686 9.314,0 6,0 C2.686,0 0,2.686 0,6 Z"
          fill="#C60000"
          fill-rule="nonzero"
          transform="translate(5.000000, 5.000000)"
        />
        <path
          d="M9.584,15.09 C9.65733333,15.09 9.71783333,15.0661667 9.7655,15.0185 C9.81316667,14.9708333 9.837,14.9103333 9.837,14.837 L9.837,14.837 L9.837,12.274 C10.2403333,12.8313333 10.8343333,13.11 11.619,13.11 C12.389,13.11 12.9665,12.8643333 13.3515,12.373 C13.7365,11.8816667 13.94,11.262 13.962,10.514 C13.9693333,10.4333333 13.973,10.3086667 13.973,10.14 C13.973,9.97133333 13.9693333,9.84666667 13.962,9.766 C13.94,9.01066667 13.7365,8.38916667 13.3515,7.9015 C12.9665,7.41383333 12.389,7.17 11.619,7.17 C10.8343333,7.17 10.2293333,7.45233333 9.804,8.017 L9.804,8.017 L9.804,7.533 C9.804,7.45233333 9.782,7.39 9.738,7.346 C9.694,7.302 9.63166667,7.28 9.551,7.28 L9.551,7.28 L9.089,7.28 C9.01566667,7.28 8.95516667,7.302 8.9075,7.346 C8.85983333,7.39 8.836,7.45233333 8.836,7.533 L8.836,7.533 L8.836,14.837 C8.836,14.9176667 8.85983333,14.98 8.9075,15.024 C8.95516667,15.068 9.01566667,15.09 9.089,15.09 L9.089,15.09 L9.584,15.09 Z M11.41,12.252 C10.9113333,12.252 10.5281667,12.0888333 10.2605,11.7625 C9.99283333,11.4361667 9.85166667,11.0493333 9.837,10.602 C9.82966667,10.5213333 9.826,10.3783333 9.826,10.173 C9.826,9.96766667 9.82966667,9.82466667 9.837,9.744 C9.85166667,9.282 9.98916667,8.8805 10.2495,8.5395 C10.5098333,8.1985 10.8966667,8.028 11.41,8.028 C12.4513333,8.028 12.972,8.732 12.972,10.14 C12.972,10.2793333 12.9683333,10.3856667 12.961,10.459 C12.939,10.9943333 12.807,11.427 12.565,11.757 C12.323,12.087 11.938,12.252 11.41,12.252 Z"
          fill="#FFFFFF"
          fill-rule="nonzero"
        />
      </g>
    </svg>
  `;
}

export function deviceClusterIcon({ deviceCount, alarmLevel, selected, className }) {
  // @todo fix icon size
  return L.divIcon({
    html: createDeviceClusterIcon({ deviceCount, alarmLevel, selected }),
    iconSize: L.point(46, 46, true),
    className
  });
}

function createDeviceClusterIcon({ deviceCount, alarmLevel, selected }) {
  let size;
  let mainColor = selected ? '#005082' : '#0079D0';
  let textColor = '#FFFFFF';
  let circleStroke = '#000000';
  let circleStrokeWidth = 0;

  if (deviceCount < 10) {
    size = 46;
  } else if (deviceCount < 100) {
    size = 56;
  } else {
    size = 66;
  }

  if (alarmLevel != null) {
    mainColor = AlarmColors[alarmLevel] || '#DFDFDF';

    if (alarmLevel === Alarms.CLEARED) {
      textColor = '#009527';
      circleStroke = '#009527';
      circleStrokeWidth = 2;
    }
  }

  return `
    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
      <defs>
        <filter id="shadow" x="0" y="0" width="200%" height="200%">
          <feGaussianBlur in="SourceGraphic" stdDeviation="1" />
        </filter>
      </defs>
      <circle
        cx="${size / 2}"
        cy="${size / 2}"
        r="${size / 2 - 2}"
        stroke="#000000"
        stroke-width="0"
        fill="#000000"
        fill-opacity=".3"
        filter="url(#shadow)"
      />
      <circle
        cx="${size / 2}"
        cy="${size / 2 - 2}"
        r="${size / 2 - 3}"
        stroke="${circleStroke}"
        stroke-width="${circleStrokeWidth}"
        fill="${mainColor}"
        fill-opacity="1"
      />
      <text
        x="50%"
        y="${size / 2 - 2}"
        fill="${textColor}"
        font-family="Rubik"
        font-size="19px"
        font-weight="300"
        text-anchor="middle"
        dominant-baseline="central"
      >
        ${deviceCount}
      </text>
    </svg>
  `;
}
